<div class="d-flex align-items-center aer-search" *ngIf="icon">
    <app-input type="search" [hint]="hint" id="staff-search-input" [control]="form.get('searchData')" [width]="'228px'" (keyup.enter)="keyChange($event)" style="padding-left:16px" [class]="'light-body-m text-s0'">
    </app-input>
    <app-image (click)="buttonOutput($event)" [src]="'./assets/icons/search_l.svg'" class="cursor"></app-image>
</div>

<div class="d-flex align-items-center aer-search" *ngIf="!icon">
    <app-input type="search" [hint]="hint" id="staff-search-input" [control]="form.get('searchData')" [width]="'228px'" (keyup.enter)="keyChange($event)" style="padding-left:16px" [class]="'light-body-m text-s0'">
    </app-input>
</div>